import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals.js';
import { BrowserRouter } from 'react-router';
import { MsalProvider } from '@azure/msal-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { msalInstance, initializeMsal } from './auth/msalInstance.js';
import { ThemeProvider } from './contexts/ThemeContext.jsx';
import { queryClient } from './lib/query/queryClient.js';
import appInsightsService from './services/appInsightsService.js';

// Devtools are dev-only and code-split so they never ship in the prod bundle.
const ReactQueryDevtools = import.meta.env.DEV
  ? React.lazy(() => import('@tanstack/react-query-devtools').then(m => ({ default: m.ReactQueryDevtools })))
  : null;
// Container Apps API endpoint - ENVIRONMENT secret updated

// Initialize Application Insights early for full coverage (Issue #190)
appInsightsService.initialize();

// Initialize MSAL to handle redirect promises
initializeMsal().then(() => {
  // Hide loading fallback once React starts loading
  const loadingFallback = document.getElementById('loading-fallback');
  if (loadingFallback) {
    loadingFallback.remove();
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ThemeProvider>
        <MsalProvider instance={msalInstance}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
            {ReactQueryDevtools && (
              <Suspense fallback={null}>
                <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
              </Suspense>
            )}
          </QueryClientProvider>
        </MsalProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
});

// Report Web Vitals to Application Insights (Issue #190 - Performance Optimization)
reportWebVitals(appInsightsService.createWebVitalsReporter());
